export const PRIMUS_PRIMARY_COLOR = '#00B0FF';
export const PRIMUS_PRIMARY_DARK_COLOR = '#2D2F37';